module.exports = __webpack_public_path__ + "img/conserje.fd409700.svg";